import { IIconBase } from '..'

const historyGenerateIcon = ({
  color = '#F0F6B8',
  height = 32,
  width = 32,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_ddd_5316_116606)'>
        <rect x='4' y='3' width='24' height='24' rx='12' fill={color} />
        <path
          d='M21.6667 14.5333V11.6933C21.6667 9.00665 21.04 8.33331 18.52 8.33331H13.48C10.96 8.33331 10.3333 9.00665 10.3333 11.6933V19.2C10.3333 20.9733 11.3067 21.3933 12.4867 20.1266L12.4933 20.12C13.04 19.54 13.8733 19.5866 14.3467 20.22L15.02 21.12'
          stroke='#131523'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.1333 21.2667C21.3115 21.2667 22.2667 20.3115 22.2667 19.1333C22.2667 17.9551 21.3115 17 20.1333 17C18.9551 17 18 17.9551 18 19.1333C18 20.3115 18.9551 21.2667 20.1333 21.2667Z'
          stroke='#131523'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M22.6667 21.6667L22 21'
          stroke='#131523'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.3333 11.6667H18.6667'
          stroke='#131523'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14 14.3333H18'
          stroke='#131523'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <filter
          id='filter0_ddd_5316_116606'
          x='0'
          y='0'
          width='32'
          height='32'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5316_116606'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.272 0 0 0 0 0.294667 0 0 0 0 0.34 0 0 0 0.12 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_5316_116606'
            result='effect2_dropShadow_5316_116606'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1'
            operator='dilate'
            in='SourceAlpha'
            result='effect3_dropShadow_5316_116606'
          />
          <feOffset />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.596078 0 0 0 0 0.630065 0 0 0 0 0.698039 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_5316_116606'
            result='effect3_dropShadow_5316_116606'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect3_dropShadow_5316_116606'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default historyGenerateIcon
